// extracted by mini-css-extract-plugin
module.exports = {"likesMetric":"liOIq1WD","likesMetric__ranking":"_1ZBgA74X","likesMetric__body":"_3nHK3Lkl","likesMetric__likesCount":"_meklZHA"};